import PrivateRoute, { Router } from 'components/app-layout/PrivateRoute';

import UserFormLayout from './containers/Form';
import UsersGridLayout from './containers/Grid';

export default function UserLayout() {
  return <Router>
    <PrivateRoute exact path="/admin/users" component={UsersGridLayout} />
    <PrivateRoute path={["/admin/users/add", "/admin/users/:id"]} component={UserFormLayout} />
  </Router>;
}
